// @flow

// Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Selectors
import datatable from '../datatable'
import assetOperations$ from '../selectors/operations'
import { jobs$ } from 'hfty-soil-jobs'
import { fields$ } from 'fc-assets'
import { crops$ } from 'fc-model-crops'
import { currentUserUnits$ } from 'hfty-users'
import { newCommentCropRecommendations$ } from 'hfty-comments-dom'

// Operator
import commentsOperator from 'hfty-operator-comments'

// Action Creator
import { addComment, deleteComments } from '../actions'
import { fetchComments } from 'hfty-comments'
// State -> Props
type Props = {
  selectedIds: Array<number>,
  currentUserUnits: string,
}

function mapStateToProps (state: Object): Props {
  return {
    selectedIds: datatable.selectors.selectedRecordIds$(state),
    operations: assetOperations$(state),
    jobs: jobs$(state),
    fields: fields$(state),
    crops: crops$(state),
    currentUserUnits: currentUserUnits$(state),
    recommendationTypeOptions: newCommentCropRecommendations$(state),
  }
}

type MapDispatchToProps = {
  actions: {
    onAdd: Function,
    onDelete: Function,
    fetchComments: Function,
    onChangeOperation: Function,
    onCancelOperations: Function,
    onSubmitOperations: Function,
  }
}

function mapDispatchToProps (dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    actions: bindActionCreators({
      onAdd: addComment,
      onDelete: deleteComments,
      fetchComments: fetchComments,
      onChangeOperation: commentsOperator.actionCreators.updateOperation,
      onCancelOperations: commentsOperator.actionCreators.cancelOperations,
      onSubmitOperations: commentsOperator.actionCreators.submitOperations,
    }, dispatch),
  }
}

// Export
export default connect(mapStateToProps, mapDispatchToProps)
